import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=49174254&scoped=true&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"
import style0 from "./trash.vue?vue&type=style&index=0&id=49174254&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49174254",
  null
  
)

export default component.exports